<template>
  <div id="glGtw">
    <el-container>
      <el-divider direction="vertical"></el-divider> <!--分割线-->
      <el-container>
        <el-header class="el-header1">
          <div style="float:right; margin-right:8px;">
            <el-button type="primary" @click="add_dvc">
              设备控制
            </el-button>
          </div>
          <!--          <el-select v-model="edi_state" ref='select1' @change="init_View()"-->
          <!--                     @visible-change='show_change1'-->
          <!--                     clearable filterable placeholder="请选择"-->
          <!--                     style="height:10px; width:200px;">-->
          <!--            <el-option-->
          <!--              v-for="item in state_options"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--              &lt;!&ndash;@click.native="show_table(httpData,roomData)"&ndash;&gt;-->
          <!--            </el-option>-->
          <!--          </el-select>-->
        </el-header>
        <el-divider style="background: #0dA7C8;"></el-divider>
        <el-main style="background:#283A4D">
          <el-table :data=tableData class="myTable_glGtw" :cell-style="tableYs" border
                    style="width:100%; font-size:13px; background:#283A4D"
                    :max-height=maxHeight show-overflow-tooltip
                    :header-cell-style="{'text-align':'center','background':'#283A4D','color':'#0dA7C8'}">
            <el-table-column width="01" sortable/>
            <div v-for="d in this.defHead">
              <el-table-column
                :prop=d.val :label=d.key width="150" sortable>
              </el-table-column>
            </div>
            <el-table-column
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button @click="change_dvc(scope.row)" type="text" size="small">控制</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog title='设备控制' center :close-on-click-modal="false"
               width="330px" height="600px" class="data-dialog"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='dailogShow'> <!--v-draggable 拖动-->
      <div style="margin-left:0;">
        开关：
        <el-radio-group v-model="radio1">
          <el-radio-button label="开启"></el-radio-button>
          <el-radio-button label="关闭"></el-radio-button>
        </el-radio-group>
        <el-button style="margin-left:10px" @click="onPwr()">发送</el-button>
      </div>
      <div style="margin-top:10px;">
        模式：
        <el-radio-group v-model="radio2">
          <el-radio-button label="制冷"></el-radio-button>
          <el-radio-button label="制热"></el-radio-button>
        </el-radio-group>
        <el-button style="margin-left:10px" @click="onMode()">发送</el-button>
      </div>
    </el-dialog>
    <el-dialog title='设备控制' center :close-on-click-modal="false"
               width="330px" height="600px" class="data-dialog"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiCtrShow'> <!--v-draggable 拖动-->
      <div style="display:flex;margin-left:0;">
        <span style="align-items: center;margin-top: 9px"> {{ name }}：</span>
        <el-input v-model="ctl_val" style="width:40%"></el-input>
        <el-button style="margin-left:5px" @click="onGn()">发送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'glGtw',
  data() {
    return {
      gnm: 3,
      dev_adr: 0,
      ctl_val: 0,
      name: 0,
      radio1: '开启',
      radio2: '制热',
      isUpdate: true,
      maxHeight: window.innerHeight - 136,
      kt_unit: localStorage.getItem("kt_unit"),
      edi_state: "",
      state_options: [{
        value: '在线',
        label: '在线'
      }, {
        value: '离线',
        label: '离线'
      }],
      treeData: [
        {id: 2}
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      db_name: [],
      db_sumData: [],
      db_todayData: [],
      defHead: [
        {'key': "序号", 'val': "item"},
        {'key': "名称", 'val': "name"},
        {'key': "状态", 'val': "dev_val"},
      ],
      tableData: [],
      xz_date: "",
      xz_type: "电量",
      dailogShow: false,
      daiCtrShow: false,
      dailog_qxbg: "#283A4D",
      dailog_qdbg: "#283A4D",
      d_type: "",
      d_mac: "",
      d_ip: "",
      d_bz: "",
    }
  },
  methods: {
    change_dvc(row) {
      console.log(row)
      this.name = row.name
      this.gnm = row.gnm
      this.dev_adr = row.dev_adr
      this.daiCtrShow = true
    },
    onGn() { /*除开关模式外功能*/
      console.log(this.radio1)
      let params = {
        'ctl': "write",
        'port': 502,
        'ctl_key': "zdy",
        'gnm': this.gnm,
        'dev_adr': this.dev_adr,
        'ctl_val': this.ctl_val,
      }
      console.log(params)
      this.isUpdate = false
      this.$api.get(this.$urls.ip + this.$urls.getOnlineWg, params)
        .then(res => {
          this.isUpdate = true
          this.db_name = res.data['data']
          console.log("控制后DDC信息", this.db_name)
          if (this.db_name["message"] === "控制成功") {
            this.$message.success(this.db_name["message"])
          } else {
            this.$message.error(this.db_name["message"])
          }
        })
        .catch(error => {
          this.isUpdate = true
          this.loading.close()
          this.$message.error("控制失败")
        })
    },
    onPwr() {
      console.log(this.radio1)
      let params = {
        'ctl': "write",
        'port': 502,
        'ctl_key': "pwr",
      }
      if (this.radio1 === "开启") {
        params["ctl_val"] = 1
      } else {
        params["ctl_val"] = 0
      }
      this.isUpdate = false
      this.$api.get(this.$urls.ip + this.$urls.getOnlineWg, params)
        .then(res => {
          this.isUpdate = true
          this.db_name = res.data['data']
          console.log("控制后DDC信息", this.db_name)
          if (this.db_name["message"] === "控制成功") {
            this.$message.success(this.db_name["message"])
          } else {
            this.$message.error(this.db_name["message"])
          }
        })
        .catch(error => {
          this.isUpdate = true
          this.loading.close()
          this.$message.error("控制失败")
        })
    },
    onMode() {
      console.log(this.radio2)
      let params = {
        'ctl': "write",
        'port': 502,
        'ctl_key': "mode",
      }
      if (this.radio2 === "制热") {
        params["ctl_val"] = 1
      } else {
        params["ctl_val"] = 2
      }
      this.isUpdate = false
      this.$api.get(this.$urls.ip + this.$urls.getOnlineWg, params)
        .then(res => {
          this.isUpdate = true
          this.db_name = res.data['data']
          console.log("控制后DDC信息", this.db_name)
          if (this.db_name["message"] === "控制成功") {
            this.$message.success(this.db_name["message"])
          } else {
            this.$message.error(this.db_name["message"])
          }
        })
        .catch(error => {
          this.isUpdate = true
          this.loading.close()
          this.$message.error("控制失败")
        })
    },
    handleSelectMenu(path) {
      console.log(path)
      this.$router.push({path: path}) /*路由跳转*/
    },
    tableYs({row, column, rowIndex, columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#283A4D;color:#ffffff'
    },
    add_dvc() { /*控制设备弹窗*/
      this.dailogShow = true
    },
    init_View() { /*初始默认时间处理*/
      let l_data = []
      for (let i = 0; i < this.db_name.length; i++) {
        let d_data = {}
        d_data['item'] = `${i}`
        d_data['name'] = this.db_name[i]['name']
        d_data['gnm'] = this.db_name[i]['gnm']
        d_data['dev_adr'] = this.db_name[i]['dev_adr']
        d_data['dev_val'] = this.db_name[i]['dev_val']
        if (d_data['name'] === "系统启停") {
          if (d_data['dev_val'] === "1") {
            d_data['dev_val'] = "启动"
          } else if (d_data['dev_val'] === "0") {
            d_data['dev_val'] = "停止"
          }
        } else if (d_data['name'] === "模式切换" || d_data['name'] === "当前模式") {
          d_data['name'] = "当前模式"
          if (d_data['dev_val'] === "1") {
            d_data['dev_val'] = "制热"
          } else if (d_data['dev_val'] === "0") {
            d_data['dev_val'] = "制冷"
          }
        }
        l_data.push(d_data)
      }
      this.tableData = l_data
      console.log(this.tableData)
      this.loading.close()
    },
    xhTime() { /*循环定时*/
      this.timer = setInterval(() => {   //设置延迟执行
        if (this.isUpdate) {
          this.get_data()
        }
      }, 30000);
      this.intervalId = setInterval(() => {
        const kt_unit1 = localStorage.getItem('kt_unit');
        if (kt_unit1 !== this.kt_unit) {
          this.kt_unit = kt_unit1;
        }
      }, 1000); // 每秒检查一次
    },
    get_data() {
      let params = {
        'ctl': "read",
        'port': 502,
      }
      this.$api.get(this.$urls.ip + this.$urls.getOnlineWg, params)
        .then(res => {
          this.db_name = res.data['data']["data"]
          this.loading.close()
          console.log("拿到DDC信息", this.db_name)
          this.init_View() /*处理初始时间*/
        })
        .catch(error => {
          this.loading.close()
          // this.$message.error("获取房间数据失败，请点击左上角刷新按钮")
        })
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip") || 'http://61.155.5.241:1123/';
    this.loading = this.$load.service({spinner: "", text: "正在加载中...", background: "rgba(0, 0, 0, 0.3)"});
    this.get_data()
    this.xhTime() /*启动轮询*/
  },
  watch: {  /*监听参数变化*/
    kt_unit(newValue, oldValue) { /*当kt_unit变化时，会触发这个watcher*/
      this.up_data()
      console.log('Value changed from', oldValue, 'to', newValue);
      // 这里可以执行你需要的操作
    }
  },
  beforeDestroy() { /*页面切换时调用*/
    clearInterval(this.timer); /*清除定时器*/
    clearInterval(this.intervalId); /*清除定时器*/
    this.timer = null;
    this.intervalId = null;
  },
}
</script>

<style>

#glGtw {
  height: 100vh;
  background: #283A4D;
  margin: 0;
  padding: 0;
}

.el-header1 {
  text-align: left;
  font-size: 12px;
  height: 50px;
  color: #FFFFFF;
  background-color: #283A4D;
}

.data-dialog {
  .el-dialog__title {
    color: rgb(255, 255, 255);
    font-weight: 900;
  }

  .el-dialog__header {
    color: rgb(255, 255, 255);
    background: #0f2941;
  }

  .el-dialog__body {
    color: rgb(255, 255, 255);
    background: #0f2941;
  }
}

.myTable_glGtw {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #283A4D !important;
    border: 5px solid #283A4D !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #283A4D;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}

.el-divider--horizontal { /*分割线样式*/
  margin: 0px 0 0px 0; /*上 右 下 左*/
  width: 100%;
  background: #0dA7C8;
}

.el-divider--vertical { /*分割线样式*/
  margin: 0px 0px 0px 0px; /*上 右 下 左*/
  width: 1px;
  height: 100vh;
  background: #0dA7C8;
}/* //background: 0 0; //border-top: 2px dashed #00ff00; */
</style>



// WEBPACK FOOTER //
// src/components/zDDC.vue